import * as colors from "@mui/material/colors";
import { alpha } from "@mui/material/styles";

function createGradient(color1, color2) {
    return `linear-gradient(to bottom, ${color1}, ${color2})`;
}

// SETUP COLORS
const GREY = {
    ...colors.grey,
    500_8: alpha(colors.grey[500], 0.08),
    500_12: alpha(colors.grey[500], 0.12),
    500_16: alpha(colors.grey[500], 0.16),
    500_24: alpha(colors.grey[500], 0.24),
    500_32: alpha(colors.grey[500], 0.32),
    500_48: alpha(colors.grey[500], 0.48),
    500_56: alpha(colors.grey[500], 0.56),
    500_80: alpha(colors.grey[500], 0.8),
};

const PRIMARY = {
    lighter: "#EDEEFF",
    light: "#C8B6FC",
    //  main: "#0070E0",
    // use standard streamlit primary 1A6CE7 | rgb(0, 112, 224)
    main: "#1A6CE7",
    dark: "#2E90FF",
    darker: "#0060CC",
    contrastText: GREY[100],
};
const SECONDARY = {
    lighter: "#B1CCFB",
    light: "#70A4FC",
    main: "#3E82F3",
    dark: "#0763FB",
    darker: "#0449BB",
    contrastText: GREY[100],
};
const INFO = {
    lighter: "#ADADB0",
    light: "#667085",
    main: "#656C7B",
    dark: "#020246",
    darker: "#000000",
    contrastText: GREY[100],
};
const SUCCESS = {
    lighter: "#CFF3BE",
    light: "#ADD69A",
    main: "#2FA84F",
    dark: "#039155",
    darker: "#187177",
    contrastText: GREY[100],
};
const WARNING = {
    lighter: "#F79C43",
    light: "#F47B36",
    main: "#F3BE0F",
    dark: "#DAAB0D",
    darker: "#C4990B",
    contrastText: "#653E03",
};
const ERROR = {
    lighter: "#DD6560",
    light: "#D73F43",
    main: "#FF4647",
    dark: "#A50806",
    darker: "#7C0506",
    contrastText: GREY[100],
};

const GRADIENTS = {
    primary: createGradient(PRIMARY.light, PRIMARY.main),
    info: createGradient(INFO.light, INFO.main),
    success: createGradient(SUCCESS.light, SUCCESS.main),
    warning: createGradient(WARNING.light, WARNING.main),
    error: createGradient(ERROR.light, ERROR.main),
};

const palette = {
    common: { black: colors.blueGrey[900], white: colors.grey["A100"] },
    primary: { ...PRIMARY },
    secondary: { ...SECONDARY },
    info: { ...INFO },
    success: { ...SUCCESS },
    warning: { ...WARNING },
    error: { ...ERROR },
    grey: GREY,
    colors: colors,
    gradients: GRADIENTS,
    divider: GREY[500_24],
    text: { primary: GREY[800], secondary: GREY[600], disabled: GREY[500] },
    background: {
        paper: colors.common.white,
        default: colors.common.white,
        neutral: GREY[200],
    },
    action: {
        active: GREY[600],
        hover: GREY[500_8],
        selected: GREY[500_16],
        disabled: GREY[500_80],
        disabledBackground: GREY[500_24],
        focus: GREY[500_24],
        hoverOpacity: 0.08,
        disabledOpacity: 0.48,
    },
};

export default palette;
